import {SalesDashboardRepository} from '../repository/SalesDashboardRepository';
import type {BaseResponse} from '../../../Data/types/BaseResponse';

export class UpdateInvoiceStatusUseCase {
  constructor (private readonly repo: SalesDashboardRepository) {}

  async execute (invoiceId: number | string, status: string): Promise<BaseResponse<unknown>> {
    return this.repo.updateInvoiceStatus(invoiceId, status);
  }
}


